<template>
  <main
    class="single-article__page-content-wrapper"
    :class="substrateArticle"
  >
    <article :class="template">
      <div
        ref="pageContent"
        class="single-article__post-content single-article__page-content single-article__content-container"
      >
        <CategoriesList
          v-if="breadcrumbs"
          class="single-article__breadcrumbs"
          :categories="breadcrumbs"
          is-breadcrumbs
          last-blocked
        />
        <h1
          v-if="article"
          class="page__title"
        >
          {{ article.title }}
        </h1>
        <TheContent
          v-for="item of content"
          :key="item.id"
          :elem="item"
        />
        <slot />
      </div>
    </article>
  </main>
</template>

<script lang="ts">
  import TheContent from '~/components/content/TheContent';
  import { Quasar } from '~/libs/Quasar';
  import CategoriesList from '~/components/CategoriesList.vue';
  import { usePageStore } from '~/store/pagesData';

  export default defineNuxtComponent({
    name: 'PageTemplate',
    components: {
      TheContent,
      CategoriesList,
    },
    props: {
      // Для верстки статичных страниц
      templateProp: {
        type: String,
        default: 'two-column',
      },
    },
    setup() {
      return {
        pageStore: usePageStore(),
      };
    },
    computed: {
      article(): ISingleArticle | null {
        return this.pageStore.currentArticle;
      },
      breadcrumbs(): IArticleCategory[] {
        return this.article?.meta.breadcrumb || [];
      },
      content(): TContent[] {
        return this.article?.content || [];
      },
      template(): string {
        const template = this.article?.template || this.templateProp;
        return `single-article__${template}`;
      },
      substrateArticle(): string {
        const template = this.article?.template || this.templateProp;
        return `single-article__substrate-${template}`;
      },
    },

    mounted() {
      Quasar.addMessageListener();
    },

    beforeUnmount() {
      Quasar.removeMessageListener();
    },
  });
</script>

<style lang="scss" src="./pages.scss" scoped></style>
